( function( $ ) {
  $( '.__tab_image p' ).on( 'click', function() {
    if( ! $( this ).closest( '.__tab_image' ).hasClass( '__active' ) ) {
      $( '.__tab_image' ).removeClass( '__active' );
      $( this ).closest( '.__tab_image' ).addClass( '__active' );

      var tab_index = $( this ).closest( '.__tab_image' ).data( 'tab' );

      $( '.__tab_content' ).removeClass( '__active' );
      $( '[data-content="' + tab_index + '"]' ).addClass( '__active' );

      if( $( window ).width() <= 1006 ) {
        $( 'html, body' ).animate( {
          scrollTop: $( '.__tab_contents' ).offset().top
        }, 1000 );
      }
    }
  } );
} ) ( jQuery );